import React from 'react';
import ReactDOM from 'react-dom';

import StockistsPromotions from '../components/stockists/StockistsPromotions';

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <StockistsPromotions />,
    document.getElementById('stockists-promotion-app'),
  );
});
